import { default as change_45passwordazTxEOwcUBMeta } from "/opt/vims-fe-live/pages/change-password.vue?macro=true";
import { default as indexAGrMIuIN6SMeta } from "/opt/vims-fe-live/pages/dashboard/index.vue?macro=true";
import { default as detailV3smZVTJ1nMeta } from "/opt/vims-fe-live/pages/departments/[id]/detail.vue?macro=true";
import { default as _91id_93sV9nybQJ4ZMeta } from "/opt/vims-fe-live/pages/departments/[id].vue?macro=true";
import { default as indexUtR3a1pp2LMeta } from "/opt/vims-fe-live/pages/departments/index.vue?macro=true";
import { default as indexKpsu7pdA2jMeta } from "/opt/vims-fe-live/pages/devices/categories/index.vue?macro=true";
import { default as _91id_93WPzzZ1iTH7Meta } from "/opt/vims-fe-live/pages/devices/details/[id].vue?macro=true";
import { default as indexhRsnlcl3xYMeta } from "/opt/vims-fe-live/pages/devices/index.vue?macro=true";
import { default as indexO0sduapK2jMeta } from "/opt/vims-fe-live/pages/documents/document-shares/index.vue?macro=true";
import { default as indexA3IvO3PvHqMeta } from "/opt/vims-fe-live/pages/documents/document-trashes/index.vue?macro=true";
import { default as indexdB9JTjowPSMeta } from "/opt/vims-fe-live/pages/documents/index.vue?macro=true";
import { default as forgot_45passwordQ3I39OtPWKMeta } from "/opt/vims-fe-live/pages/forgot-password.vue?macro=true";
import { default as indexYdOsZmZraAMeta } from "/opt/vims-fe-live/pages/histories/index.vue?macro=true";
import { default as loginw7YRczIhGiMeta } from "/opt/vims-fe-live/pages/login.vue?macro=true";
import { default as not_45authorizedrB4ds0NRLVMeta } from "/opt/vims-fe-live/pages/not-authorized.vue?macro=true";
import { default as not_45found8fG8MY8UOYMeta } from "/opt/vims-fe-live/pages/not-found.vue?macro=true";
import { default as indexM4NjFFVL9pMeta } from "/opt/vims-fe-live/pages/notifications/index.vue?macro=true";
import { default as _91id_93umf8wvG054Meta } from "/opt/vims-fe-live/pages/post-project-audits/[id].vue?macro=true";
import { default as indexBa3JF2rZMGMeta } from "/opt/vims-fe-live/pages/post-project-audits/index.vue?macro=true";
import { default as _91id_93ss1dPhR80fMeta } from "/opt/vims-fe-live/pages/print-template/[id].vue?macro=true";
import { default as index8vpVfj4arZMeta } from "/opt/vims-fe-live/pages/print-template/contact-information-on-template/index.vue?macro=true";
import { default as indexwPkQh7xtsxMeta } from "/opt/vims-fe-live/pages/print-template/create-print-template/index.vue?macro=true";
import { default as indexHgTXHuxY69Meta } from "/opt/vims-fe-live/pages/print-template/index.vue?macro=true";
import { default as indexEtOXBq25EcMeta } from "/opt/vims-fe-live/pages/print-template/print-template-param/index.vue?macro=true";
import { default as indexfPTcOxN4nQMeta } from "/opt/vims-fe-live/pages/product-erp/index.vue?macro=true";
import { default as treeBxtMCQtxELMeta } from "/opt/vims-fe-live/pages/product-erp/tree.vue?macro=true";
import { default as _91processId_93JF078RZAIkMeta } from "/opt/vims-fe-live/pages/products/[productId]/processes/[processId].vue?macro=true";
import { default as indexIWHxiR67KuMeta } from "/opt/vims-fe-live/pages/products/[productId]/processes/index.vue?macro=true";
import { default as indexRbDG9OcKOeMeta } from "/opt/vims-fe-live/pages/products/index.vue?macro=true";
import { default as formulaAUNpZgdSuYMeta } from "/opt/vims-fe-live/pages/products/product-processes/[productProcessId]/formula.vue?macro=true";
import { default as measurespKmZKuz6UJMeta } from "/opt/vims-fe-live/pages/products/product-processes/[productProcessId]/measures.vue?macro=true";
import { default as _91processId_9393zBLVvTxWMeta } from "/opt/vims-fe-live/pages/products/product-processes/[productProcessId]/processes/[processId].vue?macro=true";
import { default as indexNk96hyB3IZMeta } from "/opt/vims-fe-live/pages/products/product-processes/[productProcessId]/processes/index.vue?macro=true";
import { default as indexP1SG3p81SCMeta } from "/opt/vims-fe-live/pages/profile/index.vue?macro=true";
import { default as _91code_93uaTB0n7S11Meta } from "/opt/vims-fe-live/pages/projects/[code].vue?macro=true";
import { default as indexfawtEhEbIBMeta } from "/opt/vims-fe-live/pages/projects/index.vue?macro=true";
import { default as indexJ5nr8Zkju0Meta } from "/opt/vims-fe-live/pages/reports/index.vue?macro=true";
import { default as indexsAocfNW1cpMeta } from "/opt/vims-fe-live/pages/reports/inspection-type/index.vue?macro=true";
import { default as indexr9XZ19l1uXMeta } from "/opt/vims-fe-live/pages/reports/measure/index.vue?macro=true";
import { default as indexNLgnSwGLWhMeta } from "/opt/vims-fe-live/pages/reports/project-progress/index.vue?macro=true";
import { default as indexpAaSgfL1H7Meta } from "/opt/vims-fe-live/pages/reports/review-project/index.vue?macro=true";
import { default as indexZw7wXFPrljMeta } from "/opt/vims-fe-live/pages/reports/staff/index.vue?macro=true";
import { default as indexeo3ELN7YAsMeta } from "/opt/vims-fe-live/pages/roles/index.vue?macro=true";
import { default as indexR4G7T7STocMeta } from "/opt/vims-fe-live/pages/settings/index.vue?macro=true";
import { default as _91id_93aHrS5dA70WMeta } from "/opt/vims-fe-live/pages/speakers/[id].vue?macro=true";
import { default as indexzaKWMVFRxsMeta } from "/opt/vims-fe-live/pages/speakers/index.vue?macro=true";
import { default as editLwBUGw2pj2Meta } from "/opt/vims-fe-live/pages/staff/[id]/edit.vue?macro=true";
import { default as indexyxzvOiOS3SMeta } from "/opt/vims-fe-live/pages/staff/index.vue?macro=true";
import { default as _91id_93nmpy5ThGpaMeta } from "/opt/vims-fe-live/pages/subcontractors/[id].vue?macro=true";
import { default as index5wnnGYYk4dMeta } from "/opt/vims-fe-live/pages/subcontractors/index.vue?macro=true";
import { default as simple_45speech_45test8J4kfLRPbCMeta } from "/opt/vims-fe-live/pages/test/simple-speech-test.vue?macro=true";
import { default as speech_45text_45field24A1nJL2pbMeta } from "/opt/vims-fe-live/pages/test/speech-text-field.vue?macro=true";
import { default as _91id_931taslQqivbMeta } from "/opt/vims-fe-live/pages/users/[id].vue?macro=true";
import { default as indexm7NTV2E4l2Meta } from "/opt/vims-fe-live/pages/users/index.vue?macro=true";
export default [
  {
    name: change_45passwordazTxEOwcUBMeta?.name ?? "change-password",
    path: change_45passwordazTxEOwcUBMeta?.path ?? "/change-password",
    meta: change_45passwordazTxEOwcUBMeta || {},
    alias: change_45passwordazTxEOwcUBMeta?.alias || [],
    redirect: change_45passwordazTxEOwcUBMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/change-password.vue").then(m => m.default || m)
  },
  {
    name: indexAGrMIuIN6SMeta?.name ?? "dashboard",
    path: indexAGrMIuIN6SMeta?.path ?? "/dashboard",
    meta: indexAGrMIuIN6SMeta || {},
    alias: indexAGrMIuIN6SMeta?.alias || [],
    redirect: indexAGrMIuIN6SMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93sV9nybQJ4ZMeta?.name ?? "departments-id",
    path: _91id_93sV9nybQJ4ZMeta?.path ?? "/departments/:id()",
    children: [
  {
    name: detailV3smZVTJ1nMeta?.name ?? "departments-id-detail",
    path: detailV3smZVTJ1nMeta?.path ?? "detail",
    meta: detailV3smZVTJ1nMeta || {},
    alias: detailV3smZVTJ1nMeta?.alias || [],
    redirect: detailV3smZVTJ1nMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/departments/[id]/detail.vue").then(m => m.default || m)
  }
],
    meta: _91id_93sV9nybQJ4ZMeta || {},
    alias: _91id_93sV9nybQJ4ZMeta?.alias || [],
    redirect: _91id_93sV9nybQJ4ZMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/departments/[id].vue").then(m => m.default || m)
  },
  {
    name: indexUtR3a1pp2LMeta?.name ?? "departments",
    path: indexUtR3a1pp2LMeta?.path ?? "/departments",
    meta: indexUtR3a1pp2LMeta || {},
    alias: indexUtR3a1pp2LMeta?.alias || [],
    redirect: indexUtR3a1pp2LMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/departments/index.vue").then(m => m.default || m)
  },
  {
    name: indexKpsu7pdA2jMeta?.name ?? "devices-categories",
    path: indexKpsu7pdA2jMeta?.path ?? "/devices/categories",
    meta: indexKpsu7pdA2jMeta || {},
    alias: indexKpsu7pdA2jMeta?.alias || [],
    redirect: indexKpsu7pdA2jMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/devices/categories/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93WPzzZ1iTH7Meta?.name ?? "devices-details-id",
    path: _91id_93WPzzZ1iTH7Meta?.path ?? "/devices/details/:id()",
    meta: _91id_93WPzzZ1iTH7Meta || {},
    alias: _91id_93WPzzZ1iTH7Meta?.alias || [],
    redirect: _91id_93WPzzZ1iTH7Meta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/devices/details/[id].vue").then(m => m.default || m)
  },
  {
    name: indexhRsnlcl3xYMeta?.name ?? "devices",
    path: indexhRsnlcl3xYMeta?.path ?? "/devices",
    meta: indexhRsnlcl3xYMeta || {},
    alias: indexhRsnlcl3xYMeta?.alias || [],
    redirect: indexhRsnlcl3xYMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/devices/index.vue").then(m => m.default || m)
  },
  {
    name: indexO0sduapK2jMeta?.name ?? "documents-document-shares",
    path: indexO0sduapK2jMeta?.path ?? "/documents/document-shares",
    meta: indexO0sduapK2jMeta || {},
    alias: indexO0sduapK2jMeta?.alias || [],
    redirect: indexO0sduapK2jMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/documents/document-shares/index.vue").then(m => m.default || m)
  },
  {
    name: indexA3IvO3PvHqMeta?.name ?? "documents-document-trashes",
    path: indexA3IvO3PvHqMeta?.path ?? "/documents/document-trashes",
    meta: indexA3IvO3PvHqMeta || {},
    alias: indexA3IvO3PvHqMeta?.alias || [],
    redirect: indexA3IvO3PvHqMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/documents/document-trashes/index.vue").then(m => m.default || m)
  },
  {
    name: indexdB9JTjowPSMeta?.name ?? "documents",
    path: indexdB9JTjowPSMeta?.path ?? "/documents",
    meta: indexdB9JTjowPSMeta || {},
    alias: indexdB9JTjowPSMeta?.alias || [],
    redirect: indexdB9JTjowPSMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/documents/index.vue").then(m => m.default || m)
  },
  {
    name: forgot_45passwordQ3I39OtPWKMeta?.name ?? "forgot-password",
    path: forgot_45passwordQ3I39OtPWKMeta?.path ?? "/forgot-password",
    meta: forgot_45passwordQ3I39OtPWKMeta || {},
    alias: forgot_45passwordQ3I39OtPWKMeta?.alias || [],
    redirect: forgot_45passwordQ3I39OtPWKMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: indexYdOsZmZraAMeta?.name ?? "histories",
    path: indexYdOsZmZraAMeta?.path ?? "/histories",
    meta: indexYdOsZmZraAMeta || {},
    alias: indexYdOsZmZraAMeta?.alias || [],
    redirect: indexYdOsZmZraAMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/histories/index.vue").then(m => m.default || m)
  },
  {
    name: loginw7YRczIhGiMeta?.name ?? "login",
    path: loginw7YRczIhGiMeta?.path ?? "/login",
    meta: loginw7YRczIhGiMeta || {},
    alias: loginw7YRczIhGiMeta?.alias || [],
    redirect: loginw7YRczIhGiMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/login.vue").then(m => m.default || m)
  },
  {
    name: not_45authorizedrB4ds0NRLVMeta?.name ?? "not-authorized",
    path: not_45authorizedrB4ds0NRLVMeta?.path ?? "/not-authorized",
    meta: not_45authorizedrB4ds0NRLVMeta || {},
    alias: not_45authorizedrB4ds0NRLVMeta?.alias || [],
    redirect: not_45authorizedrB4ds0NRLVMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/not-authorized.vue").then(m => m.default || m)
  },
  {
    name: not_45found8fG8MY8UOYMeta?.name ?? "not-found",
    path: not_45found8fG8MY8UOYMeta?.path ?? "/not-found",
    meta: not_45found8fG8MY8UOYMeta || {},
    alias: not_45found8fG8MY8UOYMeta?.alias || [],
    redirect: not_45found8fG8MY8UOYMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/not-found.vue").then(m => m.default || m)
  },
  {
    name: indexM4NjFFVL9pMeta?.name ?? "notifications",
    path: indexM4NjFFVL9pMeta?.path ?? "/notifications",
    meta: indexM4NjFFVL9pMeta || {},
    alias: indexM4NjFFVL9pMeta?.alias || [],
    redirect: indexM4NjFFVL9pMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/notifications/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93umf8wvG054Meta?.name ?? "post-project-audits-id",
    path: _91id_93umf8wvG054Meta?.path ?? "/post-project-audits/:id()",
    meta: _91id_93umf8wvG054Meta || {},
    alias: _91id_93umf8wvG054Meta?.alias || [],
    redirect: _91id_93umf8wvG054Meta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/post-project-audits/[id].vue").then(m => m.default || m)
  },
  {
    name: indexBa3JF2rZMGMeta?.name ?? "post-project-audits",
    path: indexBa3JF2rZMGMeta?.path ?? "/post-project-audits",
    meta: indexBa3JF2rZMGMeta || {},
    alias: indexBa3JF2rZMGMeta?.alias || [],
    redirect: indexBa3JF2rZMGMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/post-project-audits/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ss1dPhR80fMeta?.name ?? "print-template-id",
    path: _91id_93ss1dPhR80fMeta?.path ?? "/print-template/:id()",
    meta: _91id_93ss1dPhR80fMeta || {},
    alias: _91id_93ss1dPhR80fMeta?.alias || [],
    redirect: _91id_93ss1dPhR80fMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/print-template/[id].vue").then(m => m.default || m)
  },
  {
    name: index8vpVfj4arZMeta?.name ?? "print-template-contact-information-on-template",
    path: index8vpVfj4arZMeta?.path ?? "/print-template/contact-information-on-template",
    meta: index8vpVfj4arZMeta || {},
    alias: index8vpVfj4arZMeta?.alias || [],
    redirect: index8vpVfj4arZMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/print-template/contact-information-on-template/index.vue").then(m => m.default || m)
  },
  {
    name: indexwPkQh7xtsxMeta?.name ?? "print-template-create-print-template",
    path: indexwPkQh7xtsxMeta?.path ?? "/print-template/create-print-template",
    meta: indexwPkQh7xtsxMeta || {},
    alias: indexwPkQh7xtsxMeta?.alias || [],
    redirect: indexwPkQh7xtsxMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/print-template/create-print-template/index.vue").then(m => m.default || m)
  },
  {
    name: indexHgTXHuxY69Meta?.name ?? "print-template",
    path: indexHgTXHuxY69Meta?.path ?? "/print-template",
    meta: indexHgTXHuxY69Meta || {},
    alias: indexHgTXHuxY69Meta?.alias || [],
    redirect: indexHgTXHuxY69Meta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/print-template/index.vue").then(m => m.default || m)
  },
  {
    name: indexEtOXBq25EcMeta?.name ?? "print-template-print-template-param",
    path: indexEtOXBq25EcMeta?.path ?? "/print-template/print-template-param",
    meta: indexEtOXBq25EcMeta || {},
    alias: indexEtOXBq25EcMeta?.alias || [],
    redirect: indexEtOXBq25EcMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/print-template/print-template-param/index.vue").then(m => m.default || m)
  },
  {
    name: indexfPTcOxN4nQMeta?.name ?? "product-erp",
    path: indexfPTcOxN4nQMeta?.path ?? "/product-erp",
    meta: indexfPTcOxN4nQMeta || {},
    alias: indexfPTcOxN4nQMeta?.alias || [],
    redirect: indexfPTcOxN4nQMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/product-erp/index.vue").then(m => m.default || m)
  },
  {
    name: treeBxtMCQtxELMeta?.name ?? "product-erp-tree",
    path: treeBxtMCQtxELMeta?.path ?? "/product-erp/tree",
    meta: treeBxtMCQtxELMeta || {},
    alias: treeBxtMCQtxELMeta?.alias || [],
    redirect: treeBxtMCQtxELMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/product-erp/tree.vue").then(m => m.default || m)
  },
  {
    name: _91processId_93JF078RZAIkMeta?.name ?? "products-productId-processes-processId",
    path: _91processId_93JF078RZAIkMeta?.path ?? "/products/:productId()/processes/:processId()",
    meta: _91processId_93JF078RZAIkMeta || {},
    alias: _91processId_93JF078RZAIkMeta?.alias || [],
    redirect: _91processId_93JF078RZAIkMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/products/[productId]/processes/[processId].vue").then(m => m.default || m)
  },
  {
    name: indexIWHxiR67KuMeta?.name ?? "products-productId-processes",
    path: indexIWHxiR67KuMeta?.path ?? "/products/:productId()/processes",
    meta: indexIWHxiR67KuMeta || {},
    alias: indexIWHxiR67KuMeta?.alias || [],
    redirect: indexIWHxiR67KuMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/products/[productId]/processes/index.vue").then(m => m.default || m)
  },
  {
    name: indexRbDG9OcKOeMeta?.name ?? "products",
    path: indexRbDG9OcKOeMeta?.path ?? "/products",
    meta: indexRbDG9OcKOeMeta || {},
    alias: indexRbDG9OcKOeMeta?.alias || [],
    redirect: indexRbDG9OcKOeMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: formulaAUNpZgdSuYMeta?.name ?? "products-product-processes-productProcessId-formula",
    path: formulaAUNpZgdSuYMeta?.path ?? "/products/product-processes/:productProcessId()/formula",
    meta: formulaAUNpZgdSuYMeta || {},
    alias: formulaAUNpZgdSuYMeta?.alias || [],
    redirect: formulaAUNpZgdSuYMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/products/product-processes/[productProcessId]/formula.vue").then(m => m.default || m)
  },
  {
    name: measurespKmZKuz6UJMeta?.name ?? "products-product-processes-productProcessId-measures",
    path: measurespKmZKuz6UJMeta?.path ?? "/products/product-processes/:productProcessId()/measures",
    meta: measurespKmZKuz6UJMeta || {},
    alias: measurespKmZKuz6UJMeta?.alias || [],
    redirect: measurespKmZKuz6UJMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/products/product-processes/[productProcessId]/measures.vue").then(m => m.default || m)
  },
  {
    name: _91processId_9393zBLVvTxWMeta?.name ?? "products-product-processes-productProcessId-processes-processId",
    path: _91processId_9393zBLVvTxWMeta?.path ?? "/products/product-processes/:productProcessId()/processes/:processId()",
    meta: _91processId_9393zBLVvTxWMeta || {},
    alias: _91processId_9393zBLVvTxWMeta?.alias || [],
    redirect: _91processId_9393zBLVvTxWMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/products/product-processes/[productProcessId]/processes/[processId].vue").then(m => m.default || m)
  },
  {
    name: indexNk96hyB3IZMeta?.name ?? "products-product-processes-productProcessId-processes",
    path: indexNk96hyB3IZMeta?.path ?? "/products/product-processes/:productProcessId()/processes",
    meta: indexNk96hyB3IZMeta || {},
    alias: indexNk96hyB3IZMeta?.alias || [],
    redirect: indexNk96hyB3IZMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/products/product-processes/[productProcessId]/processes/index.vue").then(m => m.default || m)
  },
  {
    name: indexP1SG3p81SCMeta?.name ?? "profile",
    path: indexP1SG3p81SCMeta?.path ?? "/profile",
    meta: indexP1SG3p81SCMeta || {},
    alias: indexP1SG3p81SCMeta?.alias || [],
    redirect: indexP1SG3p81SCMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: _91code_93uaTB0n7S11Meta?.name ?? "projects-code",
    path: _91code_93uaTB0n7S11Meta?.path ?? "/projects/:code()",
    meta: _91code_93uaTB0n7S11Meta || {},
    alias: _91code_93uaTB0n7S11Meta?.alias || [],
    redirect: _91code_93uaTB0n7S11Meta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/projects/[code].vue").then(m => m.default || m)
  },
  {
    name: indexfawtEhEbIBMeta?.name ?? "projects",
    path: indexfawtEhEbIBMeta?.path ?? "/projects",
    meta: indexfawtEhEbIBMeta || {},
    alias: indexfawtEhEbIBMeta?.alias || [],
    redirect: indexfawtEhEbIBMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: indexJ5nr8Zkju0Meta?.name ?? "reports",
    path: indexJ5nr8Zkju0Meta?.path ?? "/reports",
    meta: indexJ5nr8Zkju0Meta || {},
    alias: indexJ5nr8Zkju0Meta?.alias || [],
    redirect: indexJ5nr8Zkju0Meta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/reports/index.vue").then(m => m.default || m)
  },
  {
    name: indexsAocfNW1cpMeta?.name ?? "reports-inspection-type",
    path: indexsAocfNW1cpMeta?.path ?? "/reports/inspection-type",
    meta: indexsAocfNW1cpMeta || {},
    alias: indexsAocfNW1cpMeta?.alias || [],
    redirect: indexsAocfNW1cpMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/reports/inspection-type/index.vue").then(m => m.default || m)
  },
  {
    name: indexr9XZ19l1uXMeta?.name ?? "reports-measure",
    path: indexr9XZ19l1uXMeta?.path ?? "/reports/measure",
    meta: indexr9XZ19l1uXMeta || {},
    alias: indexr9XZ19l1uXMeta?.alias || [],
    redirect: indexr9XZ19l1uXMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/reports/measure/index.vue").then(m => m.default || m)
  },
  {
    name: indexNLgnSwGLWhMeta?.name ?? "reports-project-progress",
    path: indexNLgnSwGLWhMeta?.path ?? "/reports/project-progress",
    meta: indexNLgnSwGLWhMeta || {},
    alias: indexNLgnSwGLWhMeta?.alias || [],
    redirect: indexNLgnSwGLWhMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/reports/project-progress/index.vue").then(m => m.default || m)
  },
  {
    name: indexpAaSgfL1H7Meta?.name ?? "reports-review-project",
    path: indexpAaSgfL1H7Meta?.path ?? "/reports/review-project",
    meta: indexpAaSgfL1H7Meta || {},
    alias: indexpAaSgfL1H7Meta?.alias || [],
    redirect: indexpAaSgfL1H7Meta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/reports/review-project/index.vue").then(m => m.default || m)
  },
  {
    name: indexZw7wXFPrljMeta?.name ?? "reports-staff",
    path: indexZw7wXFPrljMeta?.path ?? "/reports/staff",
    meta: indexZw7wXFPrljMeta || {},
    alias: indexZw7wXFPrljMeta?.alias || [],
    redirect: indexZw7wXFPrljMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/reports/staff/index.vue").then(m => m.default || m)
  },
  {
    name: indexeo3ELN7YAsMeta?.name ?? "roles",
    path: indexeo3ELN7YAsMeta?.path ?? "/roles",
    meta: indexeo3ELN7YAsMeta || {},
    alias: indexeo3ELN7YAsMeta?.alias || [],
    redirect: indexeo3ELN7YAsMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/roles/index.vue").then(m => m.default || m)
  },
  {
    name: indexR4G7T7STocMeta?.name ?? "settings",
    path: indexR4G7T7STocMeta?.path ?? "/settings",
    meta: indexR4G7T7STocMeta || {},
    alias: indexR4G7T7STocMeta?.alias || [],
    redirect: indexR4G7T7STocMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/settings/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93aHrS5dA70WMeta?.name ?? "speakers-id",
    path: _91id_93aHrS5dA70WMeta?.path ?? "/speakers/:id()",
    meta: _91id_93aHrS5dA70WMeta || {},
    alias: _91id_93aHrS5dA70WMeta?.alias || [],
    redirect: _91id_93aHrS5dA70WMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/speakers/[id].vue").then(m => m.default || m)
  },
  {
    name: indexzaKWMVFRxsMeta?.name ?? "speakers",
    path: indexzaKWMVFRxsMeta?.path ?? "/speakers",
    meta: indexzaKWMVFRxsMeta || {},
    alias: indexzaKWMVFRxsMeta?.alias || [],
    redirect: indexzaKWMVFRxsMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/speakers/index.vue").then(m => m.default || m)
  },
  {
    name: editLwBUGw2pj2Meta?.name ?? "staff-id-edit",
    path: editLwBUGw2pj2Meta?.path ?? "/staff/:id()/edit",
    meta: editLwBUGw2pj2Meta || {},
    alias: editLwBUGw2pj2Meta?.alias || [],
    redirect: editLwBUGw2pj2Meta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/staff/[id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexyxzvOiOS3SMeta?.name ?? "staff",
    path: indexyxzvOiOS3SMeta?.path ?? "/staff",
    meta: indexyxzvOiOS3SMeta || {},
    alias: indexyxzvOiOS3SMeta?.alias || [],
    redirect: indexyxzvOiOS3SMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/staff/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93nmpy5ThGpaMeta?.name ?? "subcontractors-id",
    path: _91id_93nmpy5ThGpaMeta?.path ?? "/subcontractors/:id()",
    meta: _91id_93nmpy5ThGpaMeta || {},
    alias: _91id_93nmpy5ThGpaMeta?.alias || [],
    redirect: _91id_93nmpy5ThGpaMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/subcontractors/[id].vue").then(m => m.default || m)
  },
  {
    name: index5wnnGYYk4dMeta?.name ?? "subcontractors",
    path: index5wnnGYYk4dMeta?.path ?? "/subcontractors",
    meta: index5wnnGYYk4dMeta || {},
    alias: index5wnnGYYk4dMeta?.alias || [],
    redirect: index5wnnGYYk4dMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/subcontractors/index.vue").then(m => m.default || m)
  },
  {
    name: simple_45speech_45test8J4kfLRPbCMeta?.name ?? "test-simple-speech-test",
    path: simple_45speech_45test8J4kfLRPbCMeta?.path ?? "/test/simple-speech-test",
    meta: simple_45speech_45test8J4kfLRPbCMeta || {},
    alias: simple_45speech_45test8J4kfLRPbCMeta?.alias || [],
    redirect: simple_45speech_45test8J4kfLRPbCMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/test/simple-speech-test.vue").then(m => m.default || m)
  },
  {
    name: speech_45text_45field24A1nJL2pbMeta?.name ?? "test-speech-text-field",
    path: speech_45text_45field24A1nJL2pbMeta?.path ?? "/test/speech-text-field",
    meta: speech_45text_45field24A1nJL2pbMeta || {},
    alias: speech_45text_45field24A1nJL2pbMeta?.alias || [],
    redirect: speech_45text_45field24A1nJL2pbMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/test/speech-text-field.vue").then(m => m.default || m)
  },
  {
    name: _91id_931taslQqivbMeta?.name ?? "users-id",
    path: _91id_931taslQqivbMeta?.path ?? "/users/:id()",
    meta: _91id_931taslQqivbMeta || {},
    alias: _91id_931taslQqivbMeta?.alias || [],
    redirect: _91id_931taslQqivbMeta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/users/[id].vue").then(m => m.default || m)
  },
  {
    name: indexm7NTV2E4l2Meta?.name ?? "users",
    path: indexm7NTV2E4l2Meta?.path ?? "/users",
    meta: indexm7NTV2E4l2Meta || {},
    alias: indexm7NTV2E4l2Meta?.alias || [],
    redirect: indexm7NTV2E4l2Meta?.redirect || undefined,
    component: () => import("/opt/vims-fe-live/pages/users/index.vue").then(m => m.default || m)
  }
]